import { render, staticRenderFns } from "./AsnUpdate.vue?vue&type=template&id=d24f2f1a&scoped=true&"
import script from "./AsnUpdate.vue?vue&type=script&lang=js&"
export * from "./AsnUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AsnUpdate.vue?vue&type=style&index=0&id=d24f2f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24f2f1a",
  null
  
)

export default component.exports